import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../../config/api";

export const IN_PROGRESS_ORDER_COUNT_REFRESH_EVENT = "in-progress-order-count-refresh";

export const refreshInProgressOrderCount = () => {
  window.dispatchEvent(new Event(IN_PROGRESS_ORDER_COUNT_REFRESH_EVENT));
};

const useInProgressOrderCount = (enabled, pathname) => {
  const [count, setCount] = useState(0);
  const latestRequestRef = useRef(0);
  const refreshTimerRef = useRef(null);

  const fetchCount = useCallback(async () => {
    if (!enabled) return;

    const requestId = ++latestRequestRef.current;

    try {
      const response = await api.get("/order/user-orders/in-progress-count");
      const nextCount = Number(response?.data?.data?.count);

      if (requestId === latestRequestRef.current && Number.isFinite(nextCount)) {
        setCount(Math.max(0, nextCount));
      }
    } catch (error) {
      // Keep the last confirmed count when a background refresh fails.
    }
  }, [enabled]);

  useEffect(() => {
    fetchCount();
  }, [fetchCount, pathname]);

  useEffect(() => {
    if (!enabled) return undefined;

    const scheduleRefresh = () => {
      window.clearTimeout(refreshTimerRef.current);
      refreshTimerRef.current = window.setTimeout(fetchCount, 100);
    };
    const refreshWhenVisible = () => {
      if (document.visibilityState === "visible") scheduleRefresh();
    };

    window.addEventListener(IN_PROGRESS_ORDER_COUNT_REFRESH_EVENT, scheduleRefresh);
    window.addEventListener("focus", scheduleRefresh);
    document.addEventListener("visibilitychange", refreshWhenVisible);

    return () => {
      window.clearTimeout(refreshTimerRef.current);
      window.removeEventListener(IN_PROGRESS_ORDER_COUNT_REFRESH_EVENT, scheduleRefresh);
      window.removeEventListener("focus", scheduleRefresh);
      document.removeEventListener("visibilitychange", refreshWhenVisible);
    };
  }, [enabled, fetchCount]);

  return count;
};

export default useInProgressOrderCount;
